import { render } from "./IcoNownGoal.vue?vue&type=template&id=4d922ce0&ts=true"
import script from "./IcoNownGoal.vue?vue&type=script&lang=ts"
export * from "./IcoNownGoal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__